import { ATLAS_APP_BASE_URL } from '@/constants';
import assetList from '@/data/assets/org_content.json';

const env = import.meta.env.MODE;
// const fallBackLogo = require('@/assets/de-logo_md.png');
// keys used in categories to determine things aside from subcategories
const helperKeys = ['meta', 'prioritize'];

const getMap = () => {
    const orgIdMapDEV = {
        '5599ef83-3c0c-49ef-a0ea-a9cade102240': 'boeing',
        '50bbd7c0-17f9-4a0f-af54-717d13ab6937': 'capital-powers',
        '0f9eb3ee-ba9e-42c2-b6fa-570a936e5971': 'discover',
        '749e329b-f081-4214-8d74-27886d1fd078': 'discovery-education',
        '0c79de83-369b-486b-9764-8b8735fe8244': 'dupont',
        '6281301b-6004-4e3f-9abd-79edf93a1573': 'genentech',
        '7218fd39-1f8a-4da3-bf49-ed616ccf225f': 'lockheed-martin',
        '902ba65b-268b-4063-860b-61b9a5ecbd7c': 'lyda-hill',
        'ac3debf5-8a62-4ce5-b89f-fa66d299992d': 'norton',
        '0925e46a-224e-48c8-945f-9f3438ace256': 'sanofi',
        'a830bdbd-abaa-44da-a3f2-075c697de211': 'val-skinner',
        'fd9e0c07-e36f-44cf-8ed7-8f84233c1954': 'us-bank',
    };

    const orgIdMapQA = {
        'a616e027-b367-4596-b680-c8ee5c040092': 'boeing',
        'b0c0c83e-a5a2-452d-bc1d-2666f2726e19': 'capital-powers',
        'dd552fac-1f55-4417-8fe6-aafd08383eef': 'discover',
        '29420796-6b13-4d35-b68a-c73dc24a94a7': 'discovery-education',
        '4da0de60-2dc6-4993-8d6f-75ba4dd0f614': 'dupont',
        '346e96d3-9efd-4e50-8772-fafddab6d7b4': 'genentech',
        'de46d6fc-6684-4f9f-86ae-5cd4a769af34': 'lockheed-martin',
        '7691ad73-ce0c-4a20-9059-89c227a808fc': 'lyda-hill',
        '32c6a94a-ebd2-4f76-bbce-80eb1cc029c7': 'norton',
        '458271fd-2f1a-41c9-b69a-74fcf265f842': 'sanofi',
        'adfedc38-79d6-4861-b602-92267a8b0690': 'val-skinner',
        'bb21f5ea-8648-426f-bb8c-bcc3fae34684': 'us-bank',
    };

    const orgIdMap = {
        'ff59770f-d8ad-4cd0-bdda-cdbc1df383fa': 'asme',
        '73877ae0-29e6-48d7-8f48-a46007c357db': 'boeing',
        '0a55f24c-7cac-4386-a7c2-45f4053dfe97': 'capital-powers',
        '1e545a34-0c91-416c-97ab-e6e2fe5299f7': 'discover',
        'd26a0ea0-1d34-41ec-8688-84022d808739': 'discovery-education',
        '4dc4886b-b1d0-4371-880d-db5db0be328c': 'dupont',
        'e9cad66e-7785-4b51-be60-c22cd2c08b41': 'genentech',
        'e013bf4f-86a7-41a2-9e11-9ffa83eaabca': 'lockheed-martin',
        '8254ceb8-ec7d-45fb-8797-65a650e17fdb': 'lyda-hill',
        '09ba95fb-9c3e-4bbe-aee0-c4314a507bd7': 'norton',
        '1a986a09-19bb-4e4d-bf8a-0c2ba5b41f79': 'nucor',
        '575c5c47-801a-4e23-84b0-207cc8a8473d': 'sanofi',
        '60338045-2b7c-4903-b6f4-631187738211': 'trane',
        'aa27e9b9-fae2-4aa9-ab9d-4273b59f1d48': 'val-skinner',
        'b6d517de-96d1-4d88-99ac-41fa5ed9c9d6': 'us-bank',
    };

    if (env === 'development') {
        return orgIdMapDEV;
    }

    if (env === 'qa') {
        return orgIdMapQA;
    }

    return orgIdMap;
};

const getAtlasPageIdMap = () => {
    const atlasPageIdMap = {
        // '791b7b1b-4876-47fc-bb8c-e2157df9c263': 'lyda-hill',
    };
    return atlasPageIdMap;
};

const organizations = () => {
    const excludeKeys = ['evergreen'];
    const orgIds = Object.keys(assetList).filter((each) => !excludeKeys.find((key) => each.includes(key)));

    return orgIds;
};

export const getSemanticKey = (orgId) => getMap()[orgId] || orgId;

export const getAssetCategory = (assetId, orgOnly) => {
    let categories = Object.keys(assetList);

    if (orgOnly) {
        categories = categories.filter((category) => !assetList[category].meta);
    }
    // get category from asset id
    const match = categories.find((category) => {
        const isArray = !!assetList[category].length;

        if (!isArray) {
            const subcategories = Object.keys(assetList[category]).filter((key) => !helperKeys.includes(key));
            return subcategories.find((subcategory) => assetList[category][subcategory].assets.find((id) => id === assetId));
        }
        return assetList[category].find((id) => id === assetId);
    });

    return match;
};

export const getAssetContext = (assetId) => {
    // can include meta categories
    const categories = Object.keys(assetList);
    const context = {};

    // get category from asset id
    categories.forEach((category) => {
        const subcategories = Object.keys(assetList[category]).filter((key) => !helperKeys.includes(key));
        const match = subcategories.find((subcategory) => assetList[category][subcategory].assets.find((id) => id === assetId));
        if (match) {
            context[category] = {
                subcategoryDisplay: assetList[category][match].name,
                subcategory: match,
                meta: assetList[category].meta,
            };
        }
    });

    return context;
};

export const getAssetOrgId = (assetId) => {
    const map = getMap();
    const category = getAssetCategory(assetId, true);
    const ids = Object.keys(map);

    const match = ids.find((id) => map[id] === category);

    return match;
};

export const getOrgId = (key) => {
    const map = getMap();
    const ids = Object.keys(map);
    const match = ids.find((id) => map[id] === key);
    if (match) {
        return match;
    }
    return key;
};

export const getAtlasPageIdFromOrgName = (orgName) => {
    const map = getAtlasPageIdMap();
    const ids = Object.keys(map);
    const match = ids.find((id) => map[id] === orgName);
    if (match) {
        return match;
    }
    return null;
};

export const getAtlasPageIdFromOrgId = (orgId) => {
    const map = getMap();
    const orgName = map[orgId] || null;
    if (orgName) {
        return getAtlasPageIdFromOrgName(orgName);
    }
    return null;
};

// can be an organization "semantic key"
export const spotlightKey = null;

export const bannerOrder = () => {
    let order = ['lyda-hill', 'stem-day', 'digital-citizenship', 'workforce-development', 'general', 'dna-day'];

    if (spotlightKey) {
        const spotlightIdx = order.findIndex((key) => key === spotlightKey);
        if (spotlightIdx < 0) {
            return order;
        }

        order = order.toSpliced(spotlightIdx, 1);
        order.unshift(spotlightKey);
    }

    return order;
};

export const spotlights = {
    'digital-citizenship': {
        key: 'digital-citizenship',
        assetGroupTitle: 'Content Connection: Digital Citizenship',
        id: getOrgId('digital-citizenship'),
        // can be 'content' or 'organization'
        type: 'content',
        banner: {
            active: true,
            overline: 'Content Connection',
            title: 'Digital Citizenship',
            description: 'Use these resources to connect problem-solving in the classroom to problem-solving in the workplace.',
            buttons: [
                {
                    display: 'View Now',
                },
            ],
        },
    },
    'stem-day': {
        key: 'stem-day',
        assetGroupTitle: 'National STEM Day',
        id: getOrgId('stem-day'),
        // can be 'content' or 'organization'
        type: 'content',
        banner: {
            active: true,
            overline: 'Content Connection',
            title: 'National STEM Day',
            description: 'Link classroom STEM activities to real-world conversations with Career Connect Volunteers',
            buttons: [
                {
                    display: 'View Now',
                },
            ],
        },
    },
    'workforce-development': {
        key: 'workforce-development',
        assetGroupTitle: 'Spotlight on Workforce Development',
        id: getOrgId('workforce-development'),
        // can be 'content' or 'organization'
        type: 'content',
        banner: {
            active: true,
            overline: 'Spotlight on',
            title: 'Workforce Development',
            description: 'Recognize contributions of our workforce by writing and asking questions to discuss with professionals.',
            buttons: [
                {
                    display: 'View Now',
                },
            ],
        },
    },
    'lyda-hill': {
        key: 'lyda-hill',
        assetGroupTitle: 'Content Connection: Women’s History Month',
        id: getOrgId('lyda-hill'),
        type: 'organization',
        banner: {
            active: true,
            overline: 'Content Connection',
            title: 'Women’s History Month',
            description: 'View this curated collection of dynamic female leaders in science to bring your lessons to life this March and beyond',
            buttons: [
                {
                    display: 'View Now',
                },
            ],
        },
    },
    'dna-day': {
        key: 'dna-day',
        assetGroupTitle: 'Spotlight on DNA',
        id: getOrgId('dna-day'),
        // can be 'content' or 'organization'
        type: 'content',
        banner: {
            active: true,
            overline: 'Spotlight on',
            title: 'DNA',
            description: `Celebrate the workforce behind the building
                blocks of our cell structure and the advancements made through biotechnology`,
            buttons: [
                {
                    display: 'View Now',
                },
            ],
        },
    },
    general: {
        key: 'general',
        assetGroupTitle: 'Connecting Classrooms to Careers',
        // can be 'content', 'organization', or 'general'
        type: 'general',
        banner: {
            active: true,
            title: 'Connecting Classrooms to Careers',
            description: `Bring career exploration and real-world applications to your students by connecting
            them directly with experts across fields and industries`,
            buttons: [
                {
                    display: 'View Now',
                },
            ],
        },
    },
};

export const spotlight = spotlights[spotlightKey] || null;

export const getRelatedAssets = (assetId) => {
    // to be used when viewing an individual asset
    const category = getAssetCategory(assetId);
    const isArray = Array.isArray(assetList[category]);
    let related;

    if (!isArray) {
        const subcategories = Object.keys(assetList[category]).filter((subcategory) => !helperKeys.includes(subcategory));
        const subcategory = subcategories.find((each) => assetList[category][each].assets.find((id) => id === assetId));

        related = assetList[category][subcategory].assets;
    } else {
        related = assetList[category];
    }

    return related.sort(() => 0.5 - Math.random()).filter((id) => id !== assetId);
};

const removeDuplicates = (arr) => {
    return arr.filter((item, idx) => arr.indexOf(item) === idx);
};

export const resourceList = (topic, subcategory) => removeDuplicates(assetList[topic][subcategory].assets);

const getNestedAssets = (orgKey) => {
    let list = [];
    const subcategories = Object.keys(assetList[orgKey]);
    subcategories.forEach((subcategory) => {
        list = list.concat(assetList[orgKey][subcategory].assets);
    });

    return list;
};

// returns a flattened list of all assets within all subcategories
export const singleOrgContent = (key) => {
    if (!assetList[key]) {
        return [];
    }
    const list = Array.isArray(assetList[key]) ? assetList[key] : getNestedAssets(key);
    return removeDuplicates(list);
};

export const getSubcategoryContent = (key, subcategory) => removeDuplicates(assetList[key][subcategory].assets);

export const orgSubCategories = (orgId) => {
    const key = getSemanticKey(orgId);

    return Object.keys(assetList[key]);
};

export const orgContentViewAllPath = (orgId) => `${ATLAS_APP_BASE_URL}/org-${orgId}`;

export const getOrgContentArray = (orgId) => {
    const toReturn = [];
    const key = getSemanticKey(orgId);

    const orgResources = assetList[key];

    if (!orgResources) {
        return [];
    }
    const subcategories = Object.keys(orgResources);

    subcategories.forEach((subcategory) => {
        if (helperKeys.includes(subcategory)) {
            return;
        }
        toReturn.push({
            ...orgResources[subcategory],
            ...{ key: subcategory },
        });
    });
    return removeDuplicates(toReturn);
};

export const allOrgContent = (currentSpotlightKey) => {
    let list = [];

    organizations().forEach((each) => {
        if (currentSpotlightKey && currentSpotlightKey === each) {
            return;
        }
        const sourceList = singleOrgContent(each);
        list = list.concat(sourceList);
    });

    return list;
};

export const randomOrder = (arr, category) => {
    let randomized = arr.sort(() => 0.5 - Math.random());

    // handles the option for some single-category rows to always put a certain asset(s) first
    if (category && assetList[category]) {
        const { prioritize } = assetList[category];
        if (!prioritize) {
            return randomized;
        }
        const first = [];
        // if there are some that need to be prioritized, remove those and store to be placed first
        const cleanArr = arr.filter((guid) => {
            if (prioritize.includes(guid)) {
                first.push(guid);
                return false;
            }
            return true;
        });
        randomized = cleanArr.sort(() => 0.5 - Math.random());
        randomized.unshift(prioritize);
    }

    return randomized;
};

export const order = (arr) => arr.sort();

export const prioritizeAssets = [
    'c9f83110-a9d6-4e01-a017-2863018f9fff', // genentech
    'd0ce77d3-f1cc-4ded-8850-e269259e8d54', // genentech
    '25ae7b58-594a-4dfb-8043-b95d42a2c045', // genentech
    'c42799e3-f951-4c7c-a448-8d8f3e096b7f', // genentech
    '31d61785-5e6e-43d7-bec3-6c89f8fd3cea', // genentech
    'e4c591b5-8367-4145-9139-6b6a3e7fc538',
    'bbe4386d-4edb-4d37-a0e4-154baa39c380',
    '63a9db74-db94-4d18-b255-46301bd1b8fc',
    'd042e341-e031-45a2-bdea-35bb8ea7f751',
];

// to handle when a specific organization's content should be highlighted
// but some randomization still wanted to highlight different assets within the highlighted org
export const assetRandomOrder = (arr, currentSpotlight) => {
    let prioritized = arr.filter((id) => prioritizeAssets.includes(id));

    if (currentSpotlight) {
        const highlightedNumber = 4;
        const spotlightContent = singleOrgContent(currentSpotlight.key);
        const spotlightPrioritized = randomOrder(spotlightContent).slice(0, highlightedNumber);
        prioritized = [...prioritized, ...spotlightPrioritized];
    }

    const remaining = arr.filter((id) => !prioritizeAssets.includes(id));
    const orderedRemaining = randomOrder(remaining);

    return [...prioritized, ...orderedRemaining];
};

export const assetOrder = (arr) => {
    const prioritized = arr.filter((id) => prioritizeAssets.includes(id));
    const remaining = arr.filter((id) => !prioritizeAssets.includes(id));
    return [...prioritized, ...order(remaining)];
};

export const randomizeAndTruncate = (list, assetId, max = 4) =>
    list
        .sort(() => 0.5 - Math.random())
        .filter((id) => id !== assetId)
        .slice(0, max);
